import { Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';
import { RouteStateService } from '../services/route-state.service';
declare var cordova: any;


@Injectable()
export abstract class BaseService {


    isCordova: boolean = false;
    isCordovaPlatformAndroid: boolean = false;
    isCordovaPlatformiOS: boolean = false;

    protected apiUrl = environment.apiUrl;
    protected apiBaseUrl = environment.apiBaseUrl;

    constructor(
        protected httpClient: HttpClient,
        protected router: Router,
        protected route: ActivatedRoute,
        private injector: Injector
    ) {

        if (typeof (cordova) != "undefined") {
            this.isCordova = true;
      
            if (cordova.platformId === "ios")
              this.isCordovaPlatformiOS = true;
            else if (cordova.platformId === "android")
              this.isCordovaPlatformAndroid = true;
          }

    }

    protected getApiUrl(url: string) {
        return this.apiUrl + 'vca/' + url;
    }

    protected getQueryString(object: Object, excludedProperties?: string[], includedProperties?: string[]): string {

        if (object == null) {
            return "";

        }

        var queryStringValues: string[] = [];
        for (var key in object) {
            if ((excludedProperties == null ? true : excludedProperties.indexOf(key) < 0) &&
                (includedProperties == null ? true : includedProperties.indexOf(key) > -1) &&
                object[key] != null && object[key] != undefined && (object[key] instanceof File == false) && 
                (object[key] instanceof Function == false)) {
                queryStringValues.push(key + "=" + object[key]);
            }
        }
        if (queryStringValues.length > 0)
            return queryStringValues.join("&");
        else
            return "";
    }

    protected getFormData(object: Object, form?: FormData, namespace?: string, excludedProperties?: string[], includedProperties?: string[]): FormData {

        const formData = form || new FormData();
        for (let property in object) {

            if ((excludedProperties == null ? true : excludedProperties.indexOf(property) < 0) &&
                (includedProperties == null ? true : includedProperties.indexOf(property) > -1)) {

                if (!object.hasOwnProperty(property)) {
                    continue;
                }
                const formKey = namespace ? `${namespace}[${property}]` : property;
                if (object[property] instanceof Date) {
                    formData.append(formKey, object[property].toISOString());
                } else if (typeof object[property] === 'object' && !(object[property] instanceof File)) {
                    this.getFormData(object[property], formData, formKey);
                } else {
                    formData.append(formKey, object[property]);
                }

            }

        }
        return formData;
    }
}
